import {
  axiomTokens,
  Dialog as DSDialog,
  DialogContent as DSDialogContent,
  MaterialUICore,
} from '@iclinic/design-system';

const { styled } = MaterialUICore;
const { spacing } = axiomTokens;

export const Dialog = styled(DSDialog)(() => ({
  '& .MuiPaper-root': {
    maxWidth: '666px',
    width: '100%',
  },
}));

export const DialogContent = styled(DSDialogContent)(({ theme }) => ({
  padding: spacing[4],

  [theme.breakpoints.up('sm')]: {
    padding: `${spacing[4]} ${spacing[6]} ${spacing[6]}`,
  },
}));
